import { render, staticRenderFns } from "./BackgroundPlayerControls.vue?vue&type=template&id=4adcbc97&scoped=true&"
import script from "./BackgroundPlayerControls.vue?vue&type=script&lang=js&"
export * from "./BackgroundPlayerControls.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundPlayerControls.vue?vue&type=style&index=0&id=4adcbc97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adcbc97",
  null
  
)

export default component.exports